import {
    Button,
    Grid,
    Dialog,
    TextField,
    Typography
} from "@material-ui/core";

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { requestCategory } from '../api/categories'
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import { useAlert } from "react-alert";

export default function RequestCategory({ dialogValue, setDialogValue, categoryTree, providerId, user, open, handleClose,handleRequest }) {
    const alert = useAlert();


    const handleSubmit = async (e) => {
        e.preventDefault();
        // validate
        if (!dialogValue.parent) {
            alert.show("Please select parent");
            return;
        }
        if (!dialogValue.name) {
            alert.show("Please enter valid name");
            return;
        }
        if (!dialogValue.description) {
            alert.show("Please enter valid description");
            return;
        }
        console.log(dialogValue)
        // await requestCategory(dialogValue, user.token, providerId)
        setDialogValue({ parent: '', name: '', description: '' });
        handleRequest(dialogValue);
        handleClose();
    }

    const renderTree = (nodes) => (
        <TreeItem key={nodes._id} nodeId={nodes._id} label={nodes.name} style={{ background: nodes._id === dialogValue.parent ? '#ccc' : 'inherit' }}>
            {Array.isArray(nodes.children) ? nodes.children.map((node) => renderTree(node)) : null}
        </TreeItem>
    );

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth aria-labelledby="form-dialog-title">
            <form onSubmit={handleSubmit}>
                <DialogTitle>Request missing category</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        We could not find the category you requested, raise a request to add the category and we'll get back to you
                    </DialogContentText>
                    <Grid container  >
                        <Grid item xs={12}>
                            <Typography variant="caption"> Choose parent category</Typography>
                            <div style={{height: 450, overflowY: 'scroll', border: '1px solid #ccc', borderRadius: 4, padding: 8}}>
                                <TreeView
                                    defaultCollapseIcon={<ExpandMoreIcon />}
                                    defaultExpanded={['root']}
                                    onNodeSelect={(e, value) => setDialogValue({ ...dialogValue, parent: value, parent_name: e?.target?.innerText })}
                                    defaultExpandIcon={<ChevronRightIcon />}
                                >
                                    {renderTree(categoryTree)}
                                </TreeView>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                value={dialogValue.name}
                                variant="outlined"
                                onChange={(event) => setDialogValue({ ...dialogValue, name: event.target.value })}
                                label="title"
                                type="text"
                                fullWidth
                            />

                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                margin="dense"
                                id="name"
                                variant="outlined"
                                value={dialogValue.description}
                                multiline
                                rows={3}
                                onChange={(event) => setDialogValue({ ...dialogValue, description: event.target.value })}
                                label="description"
                                type="text"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                </Button>
                    <Button type="submit" color="primary">
                        Submit
                </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}